<template>
	<div class="picker-days">
		<div
			class="picker-day"
			v-for="day in days"
			:key="day.formatted"
			:class="{ selected: model == day.value }"
			@click="updateModel(day)"
		>
			<div class="picker-day-name">{{ day.name }}</div>
			<div class="picker-day-date" v-if="!day.closed">
				{{ day.formatted }}
			</div>
			<div class="picker-day-date" v-else>C</div>
		</div>
	</div>
</template>

<style scoped>
.picker-days {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.picker-day {
	width: 50px;
	height: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	padding: 8px 4px;
	font-size: 12px;
	cursor: pointer;
}

.picker-day.selected {
	background: var(--gR-base-90);
	border-radius: 5px;
}

.picker-day.selected .picker-day-name,
.picker-day.selected .picker-day-date {
	color: var(--gR-white);
}

.picker-day-name {
	color: var(--sk-grey2);
	margin-bottom: 5px;
}

.picker-day-date {
	color: var(--sk-grey3);
}
</style>

<script>
import moment from "moment"
import momentUtils from "@/moment-utils"

export default {
	name: "DeliveryDatePicker",
	props: {
		schedule: Object,
		value: null
	},
	data: function () {
		return {
			days: []
		}
	},
	computed: {
		model: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit("input", val)
			}
		}
	},
	mounted: function () {
		this.generateDays()
	},
	methods: {
		generateDays() {
			let days = []
			let today = new Date()
			let todaysDow = momentUtils.todaysDow()
			for (var i = 0; i < 5; i++) {
				const date = moment(today).add(i, "day")
				let dayOfWeek = momentUtils.normalizeDayOfWeek(date)
				let closed = true
				if (this.schedule[dayOfWeek]) {
					let openSchedule = this.schedule[dayOfWeek].find(
						(schedule) => {
							const instantlyClosed =
								schedule.closeTime == "00:00"
							if (todaysDow != dayOfWeek) {
								return !instantlyClosed
							}
							const closeTime = moment(
								schedule.closeTime,
								"HH:mm"
							)
							const todaysDate = moment(today).add(30, "minutes")
							return (
								!instantlyClosed &&
								todaysDate.isBefore(closeTime)
							)
						}
					)
					if (openSchedule) {
						closed = false
					}
				}
				days.push({
					index: i,
					value: date.format("YYYY-MM-DD"),
					date: date,
					formatted: date.format("M / DD"),
					name: i == 0 ? "Today" : date.format("ddd"),
					closed: closed
				})
			}
			this.days = days
			let selectedIndex = days.findIndex((day) => day.value == this.model)
			if (selectedIndex > -1) {
				this.updateModel(days[selectedIndex])
			} else {
				this.updateModel(days.find((day) => !day.closed))
			}
		},
		autofillDayIfNeeded() {
			let selectedIndex = this.days.findIndex(
				(day) => day.value == this.model
			)
			if (selectedIndex > -1) {
				this.updateModel(this.days[selectedIndex])
			} else {
				this.updateModel(this.days.find((day) => !day.closed))
			}
		},
		updateModel(day) {
			if (day && !day.closed) {
				this.model = day.value
			}
		}
	},
	watch: {
		schedule() {
			this.generateDays()
		}
	}
}
</script>